import React from 'react';
import { Header } from './Header';

export function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
    </div>
  );
}
